<!-- Top navigation -->
<nav class="navbar navbar-dark fixed-top flex-md-nowrap p-0 shadow">
  <a class="navbar-brand col-sm-3 col-md-2 mr-0">
    COURBENSAULE - Créateur de fiche
  </a>
</nav>
<!-- Sidebar navigation -->
<div class="container-fluid p-4 pt-5">
  <div class="row">
    <nav class="col-md-2 d-md-block pt-3 sidebar rounded" *ngIf="authService.userData">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="">
            <a class="nav-item nav-link" routerLink="dashboard" routerLinkActive="active">
              <i class="fas fa-user"></i>Profil d'utilisateur
            </a>
          </li>
          <li class="">
            <a class="nav-item nav-link" routerLink="characterSheets" routerLinkActive="active">
              <i class="fas fa-user"></i>Personnages
            </a>
          </li>
          <li class="" *ngIf="authService.userData.isAdmin">
            <a class="nav-item nav-link" routerLink="admin" routerLinkActive="active">
              <i class="fas fa-user"></i>Administration
            </a>
          </li>
          <li class="pt-4">
            <a href="https://docs.google.com/document/d/1tEi8_V1h2wUCHTiezg8XmhjR3LDuN4fgww15UqX2Icc/edit?usp=sharing" target="_blank"><i class="fas fa-user"></i>Guide de jeu de Courbensaule</a>
          </li>
          <li>
            <a href="#" (click)="openFeedback(feedback)">Signaler un problème</a>
          </li>
          <li class="mb-4">
            <button type="button" class="btn" (click)="authService.SignOut()">
              Se déconnecter
            </button>
          </li>
        </ul>
      </div>
    </nav>
    <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<ng-template #feedback let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Signaler un problème</h4>
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
      <div>Vous avez rencontré une problématique? Veuillez nous expliquer la situation, nous tâcherons d'y remédier dans les plus brefs délais.</div>
			<div class="mb-3 mt-3">
        <textarea #reportText rows="10" class="w-100 h-100"></textarea>
			</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="onSubmitReport(reportText.value)">Envoyer</button>
	</div>
</ng-template>